import React from 'react'
import { Switch, Route, withRouter, Redirect } from 'react-router-dom'

import { CityManagerRoute } from 'Config/Routing/auth'
import { PATHS } from 'Config/Routing/paths'
import { CONFIG } from '../../Config/config'

import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'

import SelfSerfSettings from 'Containers/Country/Page/SelfSerfSettings'
import Pipeline from 'Containers/Country/Page/Pipeline'
import GlobalPlaning from 'Containers/Country/Page/GlobalPlaning'
import { normalizeGraphQLConnection } from '../../shared/graphql/utils'
import Weather from '../../Containers/Country/Page/Weather'
import Channels from '../../Containers/Country/Page/Channels'
import ProjectManagement from '../../Containers/Country/Page/ProjectManagement'
import Invoices from '../../Containers/Country/Page/Invoices'
import { StrictCityManagerRoute } from './auth'

export const CountryRouter = withRouter(props => {
  const {
    match: { url },
    country,
    countryLoaded,
  } = props
  return (
    <Switch>
      <Route path={url + PATHS.countries.globalPlaning}>
        <StrictCityManagerRoute>
          {countryLoaded && country ? (
            <GlobalPlaning {...props} country={country} />
          ) : (
            <LoadingIndicator />
          )}
        </StrictCityManagerRoute>
      </Route>
      <Route path={url + PATHS.countries.pipeline}>
        <CityManagerRoute>
          {countryLoaded && country ? (
            <Pipeline {...props} country={country} />
          ) : (
            <LoadingIndicator />
          )}
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.countries.settings}>
        <CityManagerRoute>
          {countryLoaded && country ? (
            <SelfSerfSettings {...props} country={country} />
          ) : (
            <LoadingIndicator />
          )}
        </CityManagerRoute>
      </Route>
      <Route path={url + PATHS.countries.weather}>
        {countryLoaded && country ? (
          <Weather
            cities={normalizeGraphQLConnection(country.cities)}
            country={country}
            {...props}
          />
        ) : (
          <LoadingIndicator />
        )}
      </Route>
      <Route path={url + PATHS.countries.channels}>
        {countryLoaded && country ? (
          <Channels country={country} {...props} />
        ) : (
          <LoadingIndicator />
        )}
      </Route>
      <Route path={url + PATHS.countries.projectManagement}>
        {countryLoaded && country ? (
          <ProjectManagement country={country} {...props} />
        ) : (
          <LoadingIndicator />
        )}
      </Route>
      <Route
        exact
        path={url + PATHS.countries.baPayslip}
        render={() => {
          window.location.href = `${CONFIG.NEXT_BASE_URL}${url}${
            PATHS.countries.baPayslip
          }`
          return null
        }}
      />

      <Route path={url + PATHS.countries.invoices}>
        {countryLoaded && country ? (
          <Invoices country={country} {...props} />
        ) : (
          <LoadingIndicator />
        )}
      </Route>
      <Redirect from={url} to={url + PATHS.countries.globalPlaning} />
    </Switch>
  )
})
